module.exports = __webpack_public_path__ + "img/Home_Grey_Icon.c09a3ec9.png";